//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import vFooter from '../common/footer.vue'
    import {taskDetail,memberShareCreate} from '@/base/js/api'
    export default {
        name: 'app',
        data() {
            return {
                data:'',
                title:'',
                imgUrl:'',
                contentAbstract:'',
                accessToken:this._wxTool.getAccessToken(),
                isfxImg:false,
                shareText: this.data.title,
                isAdd:false
            }
        },
        created(){
            /***是否登录 begin**/
        	this._wxTool.auth();
            var member= this._wxTool.getMember();
        	if(null==member ){
        	 	console.log('need login');
            	this.$router.push('login');
            	return;
            }
            this._wxTool.setShare('',this.data.content);
           /***是否登录 end**/
             this.$vux.loading.hide()

             if(!member){
                 this.$router.push('login')
             }
            console.log(this.$route.query)
            this.title = this.$route.query.title
            this.imgUrl =  this.$route.query.imgUrl

            let params = {
                accessToken :this.accessToken,
                shareTaskId:this.$route.query.shareTaskId
            }
            taskDetail(params).then(res=>{
                if(res.code == 0){
                    console.log(res);
                    this.data = res.data.shareTask;
                    var dd=this.data.contentAbstract.replace(/<\/?.+?>/g,"");
 					var dds=dd.replace(/ /g,"");//dds为得到后的内容
                    this.contentAbstract = dds;
                }else{
                    this.$vux.toast.text(res.msg, 'middle')
                }
            })
            if(this.$route.query.shareFlag==1){
               this.isAdd= true
               this.shareText = '已加入任务，请尽快分享！'
               let params = {
                     accessToken:this.accessToken,
                     shareTaskId:this.$route.query.shareTaskId
                }

               memberShareCreate(params).then(res=>{
                   if(res.code == 0){
                        console.log(res);
                         let url =this.$url+`#/loading?memberShareId=${res.data.memberShareId}`
                        // this._wxTool.setShare(url,this.data.content);
                         let imgUrl=this.imgUrl;
                         let title=this.title;
                          console.log(title,imgUrl)
                         let content='我有奖励，你有资源吗？动动手机就能赚取奖金的平台，速来！';
                         if(this.contentAbstract.trim() != ''){
                         	content = this.contentAbstract;
                         }
                         this._wxTool.setShare(imgUrl,title,content,url);
                         this.shareText = '已加入任务，请尽快推荐！'
                         this.isAdd = true
                    }else{
                        this.$vux.toast.text(res.msg, 'middle')
                    }
               })

            }
        },
        components: {
           vFooter
        },
        methods: {
            share(){
                let params = {
                     accessToken:this.accessToken,
                     shareTaskId:this.data.shareTaskId
                }
                this.isfxImg = true
                if(this.isAdd) return;
                memberShareCreate(params).then(res=>{
                    if(res.code == 0){
                        console.log(res);
                         let url =this.$url+`#/loading?memberShareId=${res.data.memberShareId}`
                        // this._wxTool.setShare(url,this.data.content);
                         let imgUrl=this.imgUrl;
                         let title=this.title;
                         let content='我有奖励，你有资源吗？动动手机就能赚取奖金的平台，速来！';
                         if(this.contentAbstract.trim() != ''){
                         	content = this.contentAbstract;
                         }
                         this._wxTool.setShare(imgUrl,title,content,url);
                         this.shareText = '已加入任务，请尽快推荐！'
                         this.isAdd = true
                    }else{
                        this.$vux.toast.text(res.msg, 'middle')
                    }
                })
            },
            close(){
                this.isfxImg = false
            }
        }
    }



// WEBPACK FOOTER //
// ./src/pages/taskDetail/taskDetail.vue